// remove after api integration

import sortBy from 'lodash.sortby';
import reverse from 'lodash.reverse';

export default function sortingHelper<T>(
  items: T[],
  sortKey: string,
  direction: 'asc' | 'desc',
): T[] {
  let nextItems: T[] = items;

  nextItems = sortBy(nextItems, sortKey);

  if (direction === 'desc') {
    reverse(nextItems);
  }

  return nextItems;
}
